module.exports = __webpack_public_path__ + "img/safe-info-special-mng.510fdfd1.svg";